import { IconSchool, IconThumbsUp, Tag } from '@leland-dev/leland-ui-library';
import React from 'react';

import { ExperienceType } from '../../__generated-gql-types__/globalTypes';
import { formatExperienceType } from '../../utils/formatters';

interface AdditionalExperienceTagProps {
  type: ExperienceType;
}

const AdditionalExperienceTag: React.FC<AdditionalExperienceTagProps> = ({
  type,
}) => (
  <Tag
    LeftIcon={
      type === ExperienceType.ADMISSIONS_COMMITTEE ? IconSchool : IconThumbsUp
    }
    text={formatExperienceType(type)}
  />
);

export default AdditionalExperienceTag;
